var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvioLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.218,
    height: 46.241,
    viewBox: "0 0 157.218 46.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c{fill:#2fffd1;}.b{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-188 -235.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M920.608,258.445v.07a4.994,4.994,0,0,0,1.611,3.614,14.98,14.98,0,0,1,4.53,10.941v.172c0,7.84-5.353,14.388-13.817,14.388-8.117,0-13.9-6.634-13.9-14.56V272.9a14.834,14.834,0,0,1,4.524-11.012,4.875,4.875,0,0,0,1.615-3.568h0a4.773,4.773,0,0,0-7.774-3.694,23.525,23.525,0,0,0-8.814,18.446v.172c0,12.923,10.277,23.521,24.179,23.521,14.077,0,24.439-10.77,24.439-23.694V272.9a23.277,23.277,0,0,0-8.649-18.252A4.883,4.883,0,0,0,920.608,258.445Z",
    transform: "translate(-591.98 -15.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1016.17,239.945a4.435,4.435,0,1,1,4.435,4.435,4.435,4.435,0,0,1-4.435-4.435",
    transform: "translate(-699.715 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(188 236.988)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M210.064,289.772c-12.457,0-22.064-9.018-22.064-22.259v-.163c0-12.268,8.711-22.34,21.006-22.34,13.678,0,20.436,11.21,20.436,21.121a4.6,4.6,0,0,1-4.64,4.712h-26.95c1.058,6.987,6.025,10.886,12.376,10.886a15.471,15.471,0,0,0,10.177-3.737,3.677,3.677,0,0,1,2.524-.894,3.872,3.872,0,0,1,3.907,3.981,4.287,4.287,0,0,1-1.3,3.006A22.1,22.1,0,0,1,210.064,289.772Zm9.771-25.427c-.652-6.336-4.4-11.293-10.91-11.293-6.025,0-10.259,4.63-11.154,11.293Z",
    transform: "translate(-188 -245.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M487.876,291.8h-.489c-2.687,0-4.478-1.706-5.618-4.306L467.44,254.76a7.64,7.64,0,0,1-.57-2.438,4.919,4.919,0,0,1,4.885-4.712c2.687,0,4.071,1.543,4.885,3.574l11.073,28.433,11.235-28.595c.733-1.706,2.035-3.411,4.64-3.411a4.688,4.688,0,0,1,4.8,4.712,5.875,5.875,0,0,1-.57,2.355l-14.33,32.82C492.354,290.017,490.563,291.8,487.876,291.8Z",
    transform: "translate(-423.475 -247.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M776.09,252.576a4.861,4.861,0,0,1,4.885-4.956,4.93,4.93,0,0,1,4.967,4.956v33.955a4.926,4.926,0,0,1-9.852,0Z",
    transform: "translate(-684.577 -247.214)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvioLogo);
export default __webpack_public_path__ + "static/media/EVIO_logo.69351c2026c52f02436264b53396007c.svg";
export { ForwardRef as ReactComponent };